import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Table, Tag, Typography } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
export function RolesPage() {
    const roles = useQuery({
        queryKey: ['roles'],
        queryFn: async () => (await api.get('/roles')).data,
    });
    const perms = useQuery({
        queryKey: ['permissions'],
        queryFn: async () => (await api.get('/permissions')).data,
    });
    const roleCols = [
        { title: 'Kode', dataIndex: 'code', width: 160 },
        { title: 'Nama', dataIndex: 'name' },
        { title: 'Deskripsi', dataIndex: 'description' },
        {
            title: 'Jumlah Permission',
            dataIndex: 'permission_count',
            width: 180,
            render: (v) => _jsx(Tag, { color: "volcano", children: v }),
        },
    ];
    const permCols = [
        { title: 'Kode', dataIndex: 'code', width: 260 },
        { title: 'Deskripsi', dataIndex: 'description' },
    ];
    return (_jsxs("div", { children: [_jsx(Typography.Title, { level: 3, style: { marginTop: 0 }, children: "Role & Permission" }), _jsx(Card, { title: "Roles", style: { marginBottom: 16 }, children: _jsx(Table, { rowKey: "code", loading: roles.isLoading, dataSource: roles.data ?? [], columns: roleCols, pagination: false, size: "middle" }) }), _jsx(Card, { title: "Permission Registry", children: _jsx(Table, { rowKey: "code", loading: perms.isLoading, dataSource: perms.data ?? [], columns: permCols, pagination: { pageSize: 20 }, size: "middle" }) })] }));
}
